import axios from "axios";
import { store } from "../../redux/store";
import { apiBaseUrlSSO, redirectUrl } from "../env";
import { clearConfig } from "../redux/configSlice";
import { removeUser } from "../redux/userSlice";

export const Logout = async (token, signOnUrl) => {
    try {
        if (token) {
            var { configSlice } = store.getState();
            var ssoUrl = configSlice.config.ssoUrl || apiBaseUrlSSO;
            store.dispatch(clearConfig());
            store.dispatch(removeUser());
            localStorage.clear();
            sessionStorage.clear();
            await axios.post(`${ssoUrl}/api/auth/logout`, {}, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
        }
    } catch (error) {
        console.log(error);
    }
    return window.location.href = signOnUrl || redirectUrl;
}


export const redirectSSO = (signOnUrl) => {
    try {
        store.dispatch(clearConfig());
        store.dispatch(removeUser());
        localStorage.clear();
        sessionStorage.clear();
    } catch (error) {
        console.log(error)
    }
    // return window.location.href = signOnUrl || redirectUrl;
}